var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.BooksourceLinkChart)?_c('v-card',{staticClass:"p-3"},[_c('h3',{staticClass:"text-center"},[_vm._v("ช่องทางการนัดหมายเข้ารับบริการ")]),_vm._v(" "),_c('C3Chart',{attrs:{"chartData":_vm.BooksourceLinkChart}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2349485b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashbord/BookingsourceLink.vue
// module id = null
// module chunks = 